module.exports = __webpack_public_path__ + "static/media/email.b2de317b.svg";